import { render, staticRenderFns } from "./widget_card.vue?vue&type=template&id=643e6a65&scoped=true&"
import script from "./widget_card.vue?vue&type=script&lang=js&"
export * from "./widget_card.vue?vue&type=script&lang=js&"
import style0 from "./widget_card.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./widget_card.vue?vue&type=style&index=1&id=643e6a65&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e6a65",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fwidgets%2Felements%2Fwidget_card.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./widget_card.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports